<div class="list-page list-page--wide">
  <header class="page-header">
    <h1 class="page-header__title">Pending</h1>
    <p class="page-header__subtitle">
      Quotes or work assignments awaiting a decision.
    </p>
  </header>

  <div *ngIf="data?.length > 0; else placeholder">
    <ng-container *ngFor="let item of data; trackBy: trackByProjectId">
      <app-project-group
        [project]="item"
        [type]="'proposals'"
        [testIdProjectScope]="item.projectId"
        (atpSigned)="signedAtpSiteVisits = $event"
      ></app-project-group>
    </ng-container>
  </div>
  <ng-template #placeholder>
    <div *ngIf="loading; else notLoading" class="empty-state" data-testid="proposals-loading">
      <p class="empty-state__title">Loading pending projects…</p>
    </div>
    <ng-template #notLoading>
      <div class="empty-state" data-testid="proposals-empty">
        <p class="empty-state__title">No pending projects</p>
        <p class="empty-state__text">Projects awaiting your bid will appear here.</p>
      </div>
    </ng-template>
  </ng-template>
</div>

<atp-sign-accepted-dialog
  [active]="isAtpSignAccepted"
  [address]="address"
  (modalClosed)="toggleCloseAtpSignAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isAtpSignAccepted }"
  [modalHeaderTitle]="atpModalHeaderTitle"
  [modalBody]="atpModalBody"
  [dashboard]="false"
  [siteVisits]="signedAtpSiteVisits"
/>
<decline-success
  [batch]="declineBatch"
  [active]="isDeclineSuccessActive"
  [address]="address"
  [isFixedPrice]="isFixedPrice"
  [isAtp]="isAtp"
  (modalClosed)="toggleCloseDeclineSuccessModal()"
  [ngClass]="{ 'documents-dialog--active': isDeclineSuccessActive }"
/>
<accepted-offered-proposal-dialog
  [active]="isOfferAcceptedActive"
  [multiple]="isOfferAcceptedMultiple"
  (modalClosed)="toggleCloseOfferAcceptedModal()"
  [ngClass]="{ 'documents-dialog--active': isOfferAcceptedActive }"
/>
